import axios from 'axios';

import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../../../utility/Redux/modal';
import { CallAPIPromise } from '../../menu/dashboard/biiling/modal/comman';

export const GetMfgSummary = async (
  setMfgSummary,
  prefix,
  token,
  dispatch,
  fromDate,
  toDate,
  employee
) => {
  dispatch(setSpinnerLoading('Loading mfg Summary'));
  CallAPIPromise(
    '/api/saveInHouseMfg/mfgSummary',
    {
      table_prefix: prefix,
      FDATE: fromDate,
      TDATE: toDate,
      EMPLOYEE_NAME: employee,
    },
    token,
    dispatch
  )
    .then((p) => {
      if (!p.data.error) {
        const data = p.data.response;
        let rowList = [];

        for (let index = 0; index < data.length; index++) {
          rowList.push({
            ...data[index],
            id: index + 1,
          });
        }
        setMfgSummary(rowList);
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Something went wrong',
          })
        );
      }
    })
    .catch((error) => {
      console.log(error);
      if (error.response.data.name === 'TokenExpiredError') {
        dispatch(setSessionExpired(true));
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Something went wrong',
          })
        );
      }
    })
    .finally(() => {
      dispatch(setSpinnerLoading(false));
    });
};
